module.exports = require("babel-runtime/helpers/possibleConstructorReturn");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/possibleConstructorReturn"
// module id = 12
// module chunks = 0